import { render } from "./RefundPolicyPage.vue?vue&type=template&id=d280a7fe&scoped=true&ts=true"
import script from "./RefundPolicyPage.vue?vue&type=script&lang=ts"
export * from "./RefundPolicyPage.vue?vue&type=script&lang=ts"

import "./RefundPolicyPage.vue?vue&type=style&index=0&id=d280a7fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d280a7fe"]])

export default __exports__